module.exports = __webpack_public_path__ + "img/f3-2.fbdd62d1.png";